import React from 'react'
import { useSelector } from 'react-redux'
import { selectSeoItineraryData } from '../../../store/seo/seo.selectors'
import TopItineraries from './TopItineraries'
import s from './ItineraryHPText.less'

const ItineraryMainContent = () => {
  const { title, description } = useSelector(selectSeoItineraryData)

  return (
    <div className={s.textSeo}>
      <h1 className={s.textSeoTitle}>{title}</h1>
      <h2>{description}</h2>
      <TopItineraries />
    </div>
  )
}

export default ItineraryMainContent
